import { APP_INITIALIZER, inject } from '@angular/core';
import { ABP, RoutesService } from '@abp/ng.core';
import { BOOKING_PAYMENT_BASE_ROUTES } from './booking-payment-base.routes';

export const BOOKING_PAYMENTS_BOOKING_PAYMENT_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);

  return () => {
    const routes: ABP.Route[] = [...BOOKING_PAYMENT_BASE_ROUTES];
    routesService.add(routes);
  };
}
